import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=0e5b8526&scoped=true&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&id=0e5b8526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b8526",
  null
  
)

export default component.exports